import { HttpMethod } from '../types.js';
export const ApiDef_CollectionActions = {
    upgrade: {
        collections: { method: HttpMethod.POST, path: 'v1/collection-actions/upgrade/collections' },
        all: { method: HttpMethod.POST, path: 'v1/collection-actions/upgrade/all' },
    },
    check: {
        usage: { method: HttpMethod.POST, path: 'v1/collection-actions/check/usage' },
    }
};
//# sourceMappingURL=api-def.js.map